import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { IconPaths, KTSVG } from '../../../_metronic/helpers'
import styles from './styles/InfoTooltip.module.css'

interface InfoTooltipProps {
  text: React.ReactNode
  children?: React.ReactNode
  placement?: 'top' | 'bottom' | 'left' | 'right'
  className?: string
  highlight?: boolean
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  children,
  placement = 'right',
  className = '',
  highlight = false,
}) => {
  const trigger = children ? (
    children
  ) : (
    <span
      className={`
        d-inline-flex align-items-center
        ${className}
        ${highlight ? styles.tooltipHighlight : ''}
      `}
      style={{ cursor: 'pointer' }}
    >
      <KTSVG
        path={IconPaths.Info}
        className={highlight ? styles.iconWrapper : ''}
        svgClassName={highlight ? styles.iconHighlight : ''}
      />
    </span>
  )

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={`tooltip-${Math.random()}`}>{text}</Tooltip>}
    >
      <span>{trigger}</span>
    </OverlayTrigger>
  )
}
